import { render, staticRenderFns } from "./LicenseTag.vue?vue&type=template&id=261a4bda&lang=pug"
import script from "./LicenseTag.vue?vue&type=script&lang=js"
export * from "./LicenseTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports